import React from "react";

// ESDA Analysis dashboard (data-guard tool).
// Self-contained inside fe-pcmp: the component lives in ./EsdaTool.jsx (a copy of
// the ESDA tool). fe-pcmp no longer depends on fe-sml's schrockenAdmin/settings/ESDA,
// so deploying fe-pcmp alone is sufficient.
import EsdaTool from "./EsdaTool";

const EsdaDashboard = (props) => {
  return <EsdaTool {...props} />;
};

export default EsdaDashboard;
